import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Segment } from 'semantic-ui-react';
import { AdditiveDetail } from '@/components/additives/AdditiveDetail';

export default function AdditiveDetailPage() {
  return (
    <>
      <Helmet>
        <title>Miakara Soap Recipes - Additive Details</title>
      </Helmet>
      <Container>
        <Segment vertical>
          <AdditiveDetail />
        </Segment>
      </Container>
    </>
  );
} 